import React from 'react';
import {MasterLayout} from 'layout';
import {ChiTietCuocThanhTra} from 'modules/thanh-tra';

export default class ChiTietCuocThanhTraPage extends React.Component {
 
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ChiTietCuocThanhTra params={this.props.params} type='DOT_XUAT'/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/ChiTietCuocThanhTraPage.jsx